export default __webpack_public_path__ + "static/media/formas-digitales-fondo-banner-facturacion-nube.07f96642.png";